var __templateData = Handlebars.template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<ul class=\"nav nav-tabs\" role=\"tablist\" id=\"tabs-accueil\">\r\n  <li class=\"nav-item active\">\r\n    <a class=\"nav-link\" data-id=\"tous\" href=\"#section-tous\" role=\"tab\" data-toggle=\"tab\">Tous</a>\r\n  </li>\r\n</ul>\r\n<!-- Tab panes -->\r\n<div class=\"tab-content pad-no\" id=\"tab-pane-accueil\">\r\n  <div role=\"tabpanel\" class=\"tab-pane fade in active pad-no\" id=\"section-tous\"></div>\r\n</div>\r\n";
},"useData":true});
if (typeof define === 'function' && define.amd) {
  define([], function() {
    return __templateData;
  });
} else if (typeof module === 'object' && module && module.exports) {
  module.exports = __templateData;
} else {
  __templateData;
}